import { render } from "./FollowupCampaigns.vue?vue&type=template&id=70e243d3"
import script from "./FollowupCampaigns.vue?vue&type=script&lang=js"
export * from "./FollowupCampaigns.vue?vue&type=script&lang=js"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__